import { createSelector } from '@ngrx/store';

import { SearchBoxIssueItem } from '@models/search-box-issue-item';
import { IImmutableState } from 'src/shared/types/immutable-state';
import { AppState } from '../app-state';

type ImmutableCurrentSymbol = IImmutableState<Partial<SearchBoxIssueItem>>;

export const selectCurrentSymbolFeature = (state: AppState) =>
  state.currentSymbol as any as ImmutableCurrentSymbol;

export const selectCurrentSymbol = createSelector(
  selectCurrentSymbolFeature,
  (state) => state.toJS(),
);

export const selectIssueID = createSelector(
  selectCurrentSymbol,
  (state) => state.issueID,
);
